<template>
    <v-container class="pa-12 fill-height align-start" fluid>
        <v-row>
            <v-col>
                <v-btn 
                    small 
                    depressed 
                    outlined 
                    color="accent"
                    :to="`/${$i18n.locale}/administrator/creative/project/${bid.project.id}/bids`"
                ><v-icon left>mdi-arrow-left</v-icon> Back to project</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card 
                    outlined
                    max-width="600"
                    v-if="!loadingBid"
                >
                    <v-list-item>
                        <v-list-item-avatar color="grey">
                            <v-img :src="profilePicture"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline" v-text="fullName"></v-list-item-title>
                            <v-list-item-subtitle v-text="bid.user.email"></v-list-item-subtitle>
                        </v-list-item-content>
                        </v-list-item>
                    <v-divider></v-divider>
                    <div class="d-flex flex-column pa-4">
                        <div class="d-flex justify-space-between align-center mb-4">
                            <span class="overline" v-text="dateFormat(bid.bid.date.localTime)"></span>
                            <template v-if="bid.bid.isPending">
                                <v-chip small v-if="bid.bid.isPending">Pending</v-chip>
                            </template>
                            <template v-else>
                                <v-chip small color="primary" v-if="bid.bid.isApproved">Approved</v-chip>
                                <v-chip small color="secondary" v-else>Rejected</v-chip>
                            </template>                            
                        </div>
                        <div class="title" v-text="bid.bid.title"></div>
                        <div class="body-1" v-text="bid.bid.description"></div>
                        <div class="my-4" v-if="bid.bid.file">
                            <div class="overline mb-1">Document:</div>
                            <v-btn 
                                text 
                                color="primary" 
                                target="_blank" 
                                :href="`${baseImageUrl}${bid.bid.file}`"
                            ><v-icon left>mdi-file-document</v-icon> Document</v-btn>
                        </div>
                        <div class="my-4" v-if="bid.bid.videoLink">
                            <div class="overline mb-1">Video:</div>
                            <v-btn 
                                text 
                                color="secondary" 
                                target="_blank" 
                                :href="bid.bid.videoLink"
                            ><v-icon left>mdi-youtube</v-icon> Video link</v-btn>
                        </div>
                        <v-chip outlined v-text="`Project: ${bid.project.title}`"></v-chip>
                    </div>
                    <template v-if="bid.bid.isPending">
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                small
                                depressed
                                color="primary"
                                @click="verifyBid(true)"
                            >Approve</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                depressed
                                color="secondary"
                                @click="verifyBid(false)"
                            >Reject</v-btn>
                        </v-card-actions>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'

    export default {
        name: 'bidReview',
        data: () => ({
            bid: {},
            snackbar: {
                show: true,
                message: ''
            },
            loadingBid: true
        }),
        computed: {
            ...mapGetters(['user', 'baseImageUrl']),
            profilePicture() {
                return `${this.baseImageUrl}${this.bid.user.photo}`
            },
            fullName() {
                return `${this.bid.user.firstName} ${this.bid.user.lastName}`
            }
        },
        mounted() {
            this.fetchBid()
        },
        methods: {
            async fetchBid() {
                let id = this.$route.params.id
                await this.axios.get('/ProjectBid/GetProjectBid', {
                    params: {
                        id: id,
                        languageId: 1
                    }
                })
                .then(response => {
                    this.bid = response.data
                })
                this.loadingBid = false
            },
            dateFormat(date) {
                return moment(date).format('MM/DD/YYYY')
            },
            verifyBid(value) {
                const data = {
                    projectBidId: this.bid.bid.id,
                    isApproved: value,
                }
                this.axios.post('/ProjectBid/VerifyProjectBid', data)
                .then(response => {
                    this.bid.bid.isPending = false
                    this.bid.bid.isApproved = value
                    this.snackbar.message = 'Bid verified successfully'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>